import { LanguageCodeEnum as e } from "@systemeio/types";
//#region src/translations/i18n-config.ts
var t = "common", n = {
	ns: [t],
	defaultNS: t,
	supportedLngs: Object.values(e),
	lng: e.ENGLISH,
	fallbackLng: e.ENGLISH,
	load: "languageOnly",
	debug: !1,
	react: { useSuspense: !1 },
	interpolation: { escapeValue: !1 },
	returnEmptyString: !1
};
//#endregion
export { t as defaultNS, n as defaultOptions };
